import React from "react";

import { FindEstateIcon } from "../../assets";
import { EMPTY_STRING } from "../../constants";
import MainContentWrapper from "../../shared/components/main-content-wrapper/MainContentWrapper";
import Topbar from "../../layout/Topbar";
import Footer from "../../layout/Footer";

const AboutUs = () => {
  return (
    <>
      <Topbar />
      <MainContentWrapper>
        <div className="container">
          <div className="about-us-heading">About Us</div>
          <div className="about-us-page-desc">
            <h5>Bayview Shores – The Property App for Expats and Explorers</h5>
            <p><strong>Bayview Shores</strong> is a global property app designed for curious, globally minded individuals — expats, digital nomads, and those with disposable income — who want to explore all the places they could live, based on their passport, budget, and lifestyle goals.</p>
            <p>It’s not just about finding a home. It’s about unlocking your options.</p>

            <h5>Key Features:</h5>
            <ul>
              <li>
                <strong>Passport-Matching Technology:</strong> Instantly see where in the world you can live or buy property based on your passport — including visa-free destinations and countries that offer residency through property ownership.
              </li>
              <li>
                <strong>Curated Property Listings:</strong> Swipe through stylish apartments, villas, and coastal homes tailored to your budget and lifestyle — all from verified local agents.
              </li>
              <li>
                <strong>Smart Country Match Tool:</strong> Link your passport and budget to instantly discover countries where you’re eligible to purchase property or enjoy long-term stays.
              </li>
              <li>
                <strong>Price-Based Discovery:</strong> Set your budget and explore what’s available globally at your price point. The world might be more accessible than you think.
              </li>
              <li>
                <strong>Favourites & Comparisons:</strong> Shortlist homes, compare countries, and save your top picks for future planning.
              </li>
              <li>
                <strong>Agent Direct Access:</strong> Message trusted property agents directly — no middlemen, no commission taken by Bayview Shores.
              </li>
            </ul>

            <p>Whether you’re searching for a weekend getaway, a second base abroad, or a new lifestyle entirely — Bayview Shores makes global living feel closer than ever.</p>
          </div>
          <div className="about-us-features-container">
            <div className="heading text-center">
              How It works? Find a perfect home
            </div>
            <div className="features-container">
              <div className="row">
                <div className="col-12 col-sm-6 col-md-4 feature">
                  <div className="d-flex flex-column justify-content-center align-items-center gap-2">
                    <img src={FindEstateIcon} alt={EMPTY_STRING} />
                    <div className="heading text-center">Find Real Estate</div>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-4 feature">
                  <div className="d-flex flex-column justify-content-center align-items-center gap-2">
                    <img src={FindEstateIcon} alt={EMPTY_STRING} />
                    <div className="heading text-center">Meet Agent</div>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-4 feature">
                  <div className="d-flex flex-column justify-content-center align-items-center gap-2">
                    <img src={FindEstateIcon} alt={EMPTY_STRING} />
                    <div className="heading text-center">Take The Keys</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </MainContentWrapper>
    </>
  );
};

export default AboutUs;
